import {
  FAQS,
  AnalyticsHeader,
  TERMS_AND_CONDITION,
  TERMS_AND_CONDITION_ADD_ON,
  PASS_PURCHASE_SUCCESS_MESSAGE,
  TERMS_AND_CONDITION_OPT_OUT_RESTRICTED,
} from "./helper";
import { routes } from "src/shared/routes";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

export const sacramentokings_deltadental: TTeamConfig = {
  TEAM_SCHEMA: "sacramentokings_deltadental",
  TEAM_FULL_NAME: "Sacramento Kings",
  BROWSER_TITLE: "Kings Pass for Delta Dental",
  CLIENT_ID: "6b6c129ee955.seasonshare.sackings-sackings.us",

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#5b2c81",
    COLORS_SECONDARY: "#63727A",
    LOGOUT_ON_INVALID_SESSION: false,
    IS_INTERCOM_ENABLED: true,

    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
    },

    DEFAULT_APP_ROUTE: routes.landing,
    ANALYTICS_HEADER: AnalyticsHeader,
  },

  LANDING_PAGE_SETTINGS: {
    SHOW_ALL_PASSES_UNDER_BANNER: true,
    HIDE_UPCOMING_EVENTS: true,
    PASS_BANNER: {
      HIDE_PASS_DETAILS: true,
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
    },

    PASS: {
      SUBSCRIBE_BUTTON_TEXT: "Purchase Now",
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },

    STATIC_BANNER: {
      IS_ENABLED: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
    },

    SHOW_MULTIPLE_PASSES: true,
    HIDE_UPCOMING_EVENTS: true,
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: true,
    },
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
    },
  },

  IMAGES: {
    LOGO_URL:
      "https://ss-leagues.s3.amazonaws.com/NCAA/Kings-Primary-Color_Logo.png",
    LANDING_PAGE_STATIC_BANNER_URL:
      "https://ss-leagues.s3.amazonaws.com/NBA%202025/Kings%202025%20Program%20Assets/Attend%20Mobile%20%281%29.jpg",
    MOBILE_LANDING_PAGE_STATIC_BANNER_URL:
      "https://ss-leagues.s3.amazonaws.com/NBA%202025/Kings%202025%20Program%20Assets/Attend%20Mobile%20Delta%20Dental%20Vers%20-%20375x550%20%281%29.jpg",
    GROUP_INVITE_PAGE_STATIC_BANNER_URL:
      "https://ss-leagues.s3.amazonaws.com/NBA%202025/Kings%202025%20Program%20Assets/Attend%20Mobile%20%281%29.jpg",
    ORDER_SUMMERY_BACKGROUND_URL:
      "https://ss-leagues.s3.amazonaws.com/NBA 2024-25/kings-v3-assets/BACKGROUND IMAGE_1.jpg",
  },

  LANGUAGES: {
    FAQS,
    TERMS_AND_CONDITION,
    TERMS_AND_CONDITION_ADD_ON,
    PASS_PURCHASE_SUCCESS_MESSAGE,
    TERMS_AND_CONDITION_OPT_OUT_RESTRICTED,
  },
};
